import { jsx as t } from "react/jsx-runtime";
import { tv as l } from "tailwind-variants";
const n = l({
  base: ["font-bold", "font-secondary"],
  variants: {
    language: {
      HTML: "text-cyan-500",
      CSS: "text-blue-500",
      JS: "text-pink-400",
      API: "text-emerald-400"
    }
  }
}), c = ({ className: s, languages: a }) => /* @__PURE__ */ t("ul", { className: "inline-flex gap-2 items-center", children: a.map((e) => /* @__PURE__ */ t("li", { className: n({ class: s, language: e }), children: e }, e)) });
export {
  c as default
};
